import { type DateObject } from '@capsicum/common';
import { type FeedTypes, type ObjectDataShape, type PostActor, type PostTypes } from '@capsicum/socios-core';
import { type JSXElementConstructor } from 'react';

export type PartnerPost = {
	chiliz_uuid: string;
	id: number;
	name: string;
};

export interface CMSPost {
	authors: Array<string>;
	categories: Array<string>;
	desktop_image: null;
	expiration_date_gmt: null;
	fullscreen: boolean;
	image: null;
	locale: string;
	locales: Array<string>;
	min_fan_token_amount: string;
	page_url: string;
	partners: Array<PartnerPost>;
	pinned: boolean;
	post_id: number;
	publish_datetime_gmt: string;
	regulation: string;
	summary: string;
	tags: Array<string>;
	targeting_rules: null;
	title: string;
	update_datetime_gmt: string;
}

export enum PostSubTypes {
	CUSTOM = 'custom',
	DEEPLINK = 'deeplink',
	FANS_ENJOYING_PRIZES = 'fans_enjoying_prizes',
	NEWS = 'news_article',
	PARTNER = 'partner',
	POLL_OUTCOME = 'poll_outcomes'
}

export enum UploadedImageTypes {
	CHECKIN_ORIGINAL = 'checkin:original',
	CHECKIN_THUMBNAIL = 'checkin:thumbnail'
}

export enum PostHeaderType {
	MY_SOCIOS = 'mySocios',
	NO_HEADER = 'noHeader',
	PARTNER = 'partner',
	USER = 'user'
}

export type PostHeaderProps = {
	activityId: string;
	actor: PostActor;
	expireAt: DateObject | null;
	feedType: FeedTypes;
	headerType: PostHeaderType;
	mainPartner: PostMainPartner;
	object: ObjectDataShape;
	testID: string;
	time: DateObject;
	verb: PostTypes;
};

export enum PostBodyType {
	FULL_SIZE = 'fullSize',
	NO_BODY = 'noBody',
	WITH_PADDING = 'withPadding'
}

export type PostBodyProps = {
	activityId: string;
	actor: PostActor;
	bodyType: PostBodyType;
	feedType: FeedTypes;
	mainPartner: PostMainPartner;
	object: ObjectDataShape;
	sendOnClickGenericPostEvent: () => void;
	testID: string;
	time: DateObject;
	verb: PostTypes;
};

export enum PostFooterType {
	NO_FOOTER = 'noFooter'
}

export type PostFooterProps = {
	footerType: PostFooterType;
	testID: string;
};

export type PostMainPartner = {
	id: string;
	image: string;
	name: string;
	shortName: string;
};

export const DEFAULT_POST_LAYOUT = {
	body: PostBodyType.WITH_PADDING,
	footer: PostFooterType.NO_FOOTER,
	header: PostHeaderType.NO_HEADER
};

export type PostContentComponentType = JSXElementConstructor<PostBodyProps> | null;
